import React from 'react';
import GuestLayout from '../components/layouts/GuestLayout';
import { Redirect, Route, Switch } from 'react-router';
import routes from '../routes/routes';
import pages from '../routes/pages';

const GuestViews = () => {
  return (
    <GuestLayout>
      <Switch>
        {routes.map((route, i) => (
          <Route key={i} exact path={route.path} component={route.component} />
        ))}
        <Redirect to={pages.SIGN_IN.path} />
      </Switch>
    </GuestLayout>
  );
};
export default GuestViews;
